import gsap from 'gsap';

class Modal {
  constructor(element) {
    this.element = element;
    this.isInitialized = false;
    this.elements = {element};
    this.link = null;

    // Auto-bind handler methods
    Object.getOwnPropertyNames(Object.getPrototypeOf(this))
      .filter((method) => method.startsWith('handle'))
      .forEach((method) => {
        this[method] = this[method].bind(this);
      });

    this.init();
  }

  init() {
    this.findElements();
    this.bindEvents();
    this.isInitialized = true;
  }

  bindEvents() {
    console.log('binding');
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const withExitConfirmation = link.getAttribute('data-exit-confirmation');
      if (withExitConfirmation !== '') return;
      e.preventDefault();
      this.link = link;
      this.handleOpen();
    });

    this.elements.canclebutton.addEventListener('click', () => {
      this.handleClose();
    });

    this.elements.proceedbutton.addEventListener('click', () => {
      this.handleProceed();
    });
  }

  findElements() {
    const camel = (value) => value.toLowerCase().replace(/[-\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''));
    const elements = this.element.querySelectorAll('[data-item]');
    elements.forEach((element) => {
      const key = camel(element.getAttribute('data-item'));
      if (!this.elements[key]) this.elements[key] = element;
      else if (Array.isArray(this.elements[key])) this.elements[key].push(element);
      else this.elements[key] = [this.elements[key], element];
    });
  }

  handleOpen() {
    gsap.set(this.element, {opacity: 0, display: 'none'}, '0');
    gsap.to(this.element, {opacity: 1, display: 'block'}, '0');
  }

  handleClose() {
    this.link = null;
    gsap.to(this.element, {opacity: 0});
    gsap.set(this.element, {display: 'none'}, '+=1');
  }

  handleProceed() {
    if (!(this.link instanceof HTMLAnchorElement)) return;

    const href = this.link.getAttribute('href');
    const target = this.link.getAttribute('target');

    if (!href) return;

    // Check if the link opens in a new tab
    if (target === '_blank') window.open(href, '_blank');
    else window.location.href = href;
  }
}

/**
 * Check for nav in DOM because some marketing
 * landing pages don't have a navigation.
 */
const modal = document.querySelector('[data-ref="modal"]');
if (modal) new Modal(modal);
